
export const hasRole = (roles, role) => {
  if (!roles) return false;
  for (const userRole of roles) {
    if (userRole.role === role) return true;
  }
  return false;
};